export const torchButtonSelector = ({torchButton}) => torchButton